class HtmlControlComponent {
	
	constructor() {
	}
	
	async init(options) {
		const { init } = await import(/* webpackChunkName: "tinymce" */ './tinymce_editor');

		this.editor = await init(options);

        if( this.editor && this.pendingValue ) {
        	this.editor.setValue(this.pendingValue);
        	this.pendingValue = null;   
        }
	}	
	
	setValue(value) {
		if( this.editor ) {
			this.editor.setValue(value);			
		} else {
			this.pendingValue = value;
		}
    }
	
	getValue() {
		if( this.editor ) {
			return this.editor.getValue();
		} else {
			return this.pendingValue;
		}
	}
	
	destroy() {
		if( this.editor ) {
			this.editor.destroy();
			this.editor = null;
		}
	}
}

const HTMLTextArea = (width) => {
	return new HtmlControlComponent(width);
};

export {
	HTMLTextArea
}